import React from "react";
import {
    Route,
    Redirect,
    RouteProps,
    RouteComponentProps
} from "react-router-dom";

import { APICore } from "../helpers/api/apiCore";

interface PrivateRouteProps {
    component: React.FunctionComponent<RouteProps>;
    roles?: string;
    funcao?: number;
    funcoes?: number[];
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({
    component: Component,
    roles,
    funcao,
    funcoes,
    ...rest
}: PrivateRouteProps) => {
    const api = new APICore();

    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) => {
                if (api.isUserAuthenticated() === false) {
                    // not logged in so redirect to login page with the return url
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: props["location"] }
                            }}
                        />
                    );
                }

                const loggedInUser = api.getLoggedInUser();
                const userFuncoes = loggedInUser?.usuario?.gruposistema?.funcoes ?? [];

                let hasAccess = true;
                if (funcoes?.length) {
                    hasAccess = userFuncoes.some(
                        (funcaoItem: any) => funcoes.includes(funcaoItem.id)
                    );
                } else if (funcao) {
                    hasAccess = !!userFuncoes.find(
                        (funcaoItem: any) => funcaoItem.id === funcao
                    );
                }

                if ((funcao || (funcoes?.length ?? 0) > 0) && !hasAccess) {
                    return <Redirect to={{ pathname: "/" }} />;
                }

                // check if route is restricted by role
                if (roles && roles.indexOf(loggedInUser.role) === -1) {
                    // role not authorised so redirect to home page
                    return <Redirect to={{ pathname: "/" }} />;
                }
                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
